import { render, staticRenderFns } from "./MemoPhraseSelector.vue?vue&type=template&id=c2dc540e&scoped=true&lang=pug&"
import script from "./MemoPhraseSelector.vue?vue&type=script&lang=ts&"
export * from "./MemoPhraseSelector.vue?vue&type=script&lang=ts&"
import style0 from "./MemoPhraseSelector.vue?vue&type=style&index=0&id=c2dc540e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2dc540e",
  null
  
)

export default component.exports